import { INITIAL_COLUMNS_STATE } from "../Toolbar/utils";

export const productMasterStoreSlice = (set) => ({
  productMasterSearch: "",
  productMasterColumns: INITIAL_COLUMNS_STATE,
  productMasterStSelectedOwners: [],
  productMasterSelectedKam: [],
  productMasterStDomains: [
    { domain: "Domain 1", id: 1 },
    { domain: "Domain 2", id: 2 },
  ],
  productMasterStSelectedDomains: [],
  productMasterSelectedBrand: [],
  productMasterModules: ["Forecast", "Sales Tracking"],
  productMasterSelectedModules: [],
  productMasterSelectedCategory: null,
  productMasterChannels: {
    ALL: "Todos los canales",
    MELI: "Mercado Libre",
    AMZN: "Amazon",
    VTEX: "VTEX",
    OFF: "OFF",
  },
  productMasterSelectedChannels: [],
  isAllChannelsSelected: false,
  isProductSelected: false,
  productMasterPaginationModel: {
    page: 0,
    pageSize: 25,
  },
  localChannels: {},
  productMasterSelectionModel: [],
  productMasterShowInactive: true,

  setProductMasterSearch: (search) =>
    set(() => ({ productMasterSearch: search })),
  setProductMasterSelectedBrand: (brand) =>
    set({ productMasterSelectedBrand: brand }),

  toggleProductMasterStSelectedOwners: (owner) =>
    set({ productMasterStSelectedOwners: owner }),
  clearProductMasterStSelectedOwners: () =>
    set(() => ({ productMasterStSelectedOwners: [] })),
  toggleProductMasterStSelectedDomains: (domain) =>
    set((state) => {
      const alreadySelected =
        state.productMasterStSelectedDomains.includes(domain);

      return {
        productMasterStSelectedDomains: alreadySelected
          ? state.productMasterStSelectedDomains.filter((d) => d !== domain)
          : [...state.productMasterStSelectedDomains, domain],
      };
    }),

  setProductMasterStSelectedDomains: (domain) =>
    set({ productMasterStSelectedDomains: domain }),

  clearProductMasterStSelectedDomains: () =>
    set(() => ({ productMasterStSelectedDomains: [] })),
  clearProductMasterSelectedBrand: () =>
    set(() => ({
      productMasterSelectedBrand: [],
    })),
  setProductMasterSelectedModules: (module) =>
    set((state) => {
      const alreadySelected =
        state.productMasterSelectedModules.includes(module);
      return {
        productMasterSelectedModules: alreadySelected
          ? state.productMasterSelectedModules.filter((m) => m !== module)
          : [...state.productMasterSelectedModules, module],
      };
    }),
  resetProductMasterSelectedModules: () =>
    set(() => ({ productMasterSelectedModules: [] })),
  setProductMasterSelectedChannels: (channelKey) =>
    set((state) => {
      const allKeys = Object.keys(state.productMasterChannels).filter(
        (k) => k !== "ALL",
      );
      const selected = state.productMasterSelectedChannels;

      if (channelKey === "ALL") {
        return {
          productMasterSelectedChannels: selected.includes("ALL")
            ? [] // desmarcar todo
            : [...allKeys, "ALL"], // seleccionar todos
        };
      }

      const isSelected = selected.includes(channelKey);
      let updatedSelected = isSelected
        ? selected.filter((c) => c !== channelKey)
        : [...selected, channelKey];

      const hasAll = allKeys.every((k) => updatedSelected.includes(k));

      if (hasAll && !updatedSelected.includes("ALL")) {
        updatedSelected.push("ALL");
      }

      if (!hasAll && updatedSelected.includes("ALL")) {
        updatedSelected = updatedSelected.filter((c) => c !== "ALL");
      }

      return {
        productMasterSelectedChannels: updatedSelected,
      };
    }),
  setIsAllChannelsSelected: (isAll) => set({ isAllChannelsSelected: isAll }),
  resetProductMasterSelectedChannels: () =>
    set(() => ({ productMasterSelectedChannels: [] })),
  setProductMasterSelectedCategory: (selectedCategory) =>
    set(() => ({ productMasterSelectedCategory: selectedCategory })),
  clearProductMasterSelectedCategory: () =>
    set(() => ({ productMasterSelectedCategory: null })),
  setIsProductSelected: (isSelected) =>
    set(() => ({ isProductSelected: isSelected })),
  setProductMasterPaginationModel: (model) =>
    set({ productMasterPaginationModel: model }),
  setLocalChannels: (channels) => set(() => ({ localChannels: channels })),
  resetProductMasterLocalChannels: () => set(() => ({ localChannels: {} })),
  setProductMasterSelectionModel: (selection) =>
    set(() => ({ productMasterSelectionModel: selection })),
  deleteChannelFromLocalChannels: (channelToRemove, sku) =>
    set((state) => {
      const currentChannels = state.localChannels[sku] || [];
      const updatedChannels = currentChannels.filter(
        (ch) => ch !== channelToRemove,
      );

      if (updatedChannels.length > 0) {
        return {
          localChannels: {
            ...state.localChannels,
            [sku]: updatedChannels,
          },
        };
      } else {
        const { [sku]: removed, ...rest } = state.localChannels;
        return {
          localChannels: rest,
        };
      }
    }),

  toggleProductMasterShowInactive: () =>
    set((state) => ({
      productMasterShowInactive: !state.productMasterShowInactive,
    })),

  ProductMasterClearFilters: () =>
    set(() => ({
      productMasterSearch: "",
      productMasterStSelectedOwners: [],
      productMasterSelectedBrand: [],
      localChannels: {},
      productMasterPaginationModel: {
        page: 0,
        pageSize: 25,
      },
    })),
  toggleProductMasterColumns: (field, value) =>
    set((state) => ({
      productMasterColumns: {
        ...state.productMasterColumns,
        [field]: value,
      },
    })),
  resetProductMasterColumns: () =>
    set(() => ({
      productMasterColumns: INITIAL_COLUMNS_STATE,
    })),
  toggleProductMasterSelectedKam: (kam) =>
    set((state) => {
      const alreadySelected = state.productMasterSelectedKam.includes(kam);
      return {
        productMasterSelectedKam: alreadySelected
          ? state.productMasterSelectedKam.filter((k) => k !== kam)
          : [...state.productMasterSelectedKam, kam],
      };
    }),
  setProductMasterSelectedKam: (kam) =>
    set({ productMasterSelectedKam: kam }),
  clearProductMasterSelectedKam: () =>
    set(() => ({ productMasterSelectedKam: [] })),
});
